<form
  [formGroup]="formProfile"
  (ngSubmit)="onSubmitProfile()"
  #formRef="ngForm"
  [patchForm]="optionValueProfile$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsedProfile ? 'false' : 'true'"
          (click)="isCollapsedProfile = !isCollapsedProfile"
          aria-controls="memberProfile"
        >
          <span class="fs-3"> {{ 'general.memberProfile' | translate }} </span>
          <i
            class="fa fa-fw"
            [ngClass]="isCollapsedProfile ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsedProfile" class="card-body" id="memberProfile">
      <div class="nav nav-segment my-2">
        <button
          type="button"
          (click)="$event.preventDefault(); setFormMemberProfileValues()"
          class="nav-segment nav-link"
          [ngClass]="!cfIsSelectedInMemberForm ? ' active' : ''"
        >
          {{
            'configurationOptionModule.apProductGroupPurchaseFlow' | translate
          }}
        </button>

        <button
          type="button"
          (click)="$event.preventDefault(); setFormMemberProfileValues()"
          class="nav-segment nav-link"
          [ngClass]="cfIsSelectedInMemberForm ? ' active' : ''"
        >
          {{
            'configurationOptionModule.cfProductGroupPurchaseFlow' | translate
          }}
        </button>
      </div>
      <fieldset formGroupName="firstName">
        <legend class="h4" id="profFirstNameLabel">{{
          'general.firstName' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="firstNameVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('firstName')"
              />
              <label for="firstNameVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="firstNameRequired"
                checked
                formControlName="isRequired"
              />
              <label for="firstNameRequired">{{
                'general.isRequired' | translate | titlecase | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="firstNameEditable"
                formControlName="isEditable"
              />
              <label for="firstNameEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="fistNameDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc1"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profFirstNameLabel fistNameDesc flag-nl-idc1"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc1"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profFirstNameLabel fistNameDesc flag-en-idc1"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc1"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profFirstNameLabel fistNameDesc flag-fr-idc1"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc1"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profFirstNameLabel fistNameDesc flag-de-idc1"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="middleName"
        ><legend class="h4" id="profMiddleNameLabel">{{
          'general.middleName' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="middleNameVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('middleName')"
              />
              <label for="middleNameVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="middleNameRequired"
                formControlName="isRequired"
              />
              <label for="middleNameRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="middleNameEditable"
                formControlName="isEditable"
              />
              <label for="middleNameEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>

          <div class="col">
            <label class="form-label" id="middleNameDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc2"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMiddleNameLabel middleNameDesc flag-nl-idc2"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc2"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMiddleNameLabel middleNameDesc flag-en-idc2"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc2"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMiddleNameLabel middleNameDesc flag-fr-idc2"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc2"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMiddleNameLabel middleNameDesc flag-en-idc2"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="lastName">
        <legend class="h4" id="profLastNameLabel">{{
          'general.lastName' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="lastNameVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('lastName')"
              />
              <label for="lastNameVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="lastNameRequired"
                checked
                formControlName="isRequired"
              />
              <label for="lastNameRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="lastNameEditable"
                formControlName="isEditable"
              />
              <label for="lastNameEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="lastNameDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc3"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profLastNameLabel lastNameDesc flag-nl-idc3"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc3"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profLastNameLabel lastNameDesc flag-en-idc3"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc3"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profLastNameLabel lastNameDesc flag-fr-idc3"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc3"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profLastNameLabel lastNameDesc flag-de-idc3"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="birthDate"
        ><legend class="h4" id="profBirthDateLabel">{{
          'general.birthDate' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="birthDateVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('birthDate')"
              />
              <label for="birthDateVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="birthDateRequired"
                checked
                formControlName="isRequired"
              />
              <label for="birthDateRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="birthDateEditable"
                formControlName="isEditable"
              />
              <label for="birthDateEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="birthDateDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc4"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBirthDateLabel birthDateDesc flag-nl-idc4"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc4"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBirthDateLabel birthDateDesc flag-en-idc4"
                    formControlName="title_en"
                  />
                </div>
              </div>

              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc4"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBirthDateLabel birthDateDesc flag-fr-idc4"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc4"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBirthDateLabel birthDateDesc flag-de-idc4"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="phone">
        <legend class="h4" id="profPhoneLabel">{{
          'general.phoneNumber' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="phoneVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('phone')"
              />
              <label for="phoneVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="phoneRequired"
                checked
                formControlName="isRequired"
              />
              <label for="phoneRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="phoneEditable"
                formControlName="isEditable"
              />
              <label for="phoneEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="phoneNumDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc5"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profPhoneLabel phoneNumDesc flag-nl-idc5"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc5"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profPhoneLabel phoneNumDesc flag-en-idc5"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc5"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profPhoneLabel phoneNumDesc flag-fr-idc5"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc5"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profPhoneLabel phoneNumDesc flag-de-idc5"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="shouldSync">
        <legend class="h4" id="profShouldSyncLabel">{{
          'general.shouldSync' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="shouldSyncVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('shouldSync')"
              />
              <label for="shouldSyncVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="shouldSyncRequired"
                checked
                formControlName="isRequired"
              />
              <label for="shouldSyncRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="shouldSyncEditable"
                formControlName="isEditable"
              />
              <label for="shouldSyncEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="syncDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc6"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profShouldSyncLabel syncDesc flag-nl-idc6"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc6"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profShouldSyncLabel syncDesc flag-en-idc6"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc6"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profShouldSyncLabel syncDesc flag-fr-idc6"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc6"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profShouldSyncLabel syncDesc flag-de-idc6"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="mobile">
        <legend class="h4" id="profMobileLabel">{{
          'general.mobile' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="mobileVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('mobile')"
              />
              <label for="mobileVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="mobileRequired"
                checked
                formControlName="isRequired"
              />
              <label for="mobileRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="mobileEditable"
                formControlName="isEditable"
              />
              <label for="mobileEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="mobileDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc7"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMobileLabel mobileDesc flag-nl-idc7"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc7"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMobileLabel mobileDesc flag-en-idc7"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc7"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMobileLabel mobileDesc flag-fr-idc7"
                    formControlName="title_fr"
                  />
                </div>
              </div>

              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc7"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMobileLabel mobileDesc flag-de-idc7"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="category">
        <legend class="h4" id="profCatLabel">{{
          'general.category' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="categoryVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('category')"
              />
              <label for="categoryVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="categoryRequired"
                checked
                formControlName="isRequired"
              />
              <label for="categoryRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="categoryEditable"
                formControlName="isEditable"
              />
              <label for="categoryEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profCatDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc27"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCatLabel profCatDesc flag-nl-idc27"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc27"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCatLabel profCatDesc flag-en-idc27"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc27"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCatLabel profCatDesc flag-fr-idc27"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc27"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCatLabel profCatDesc flag-de-idc27"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="email">
        <legend class="h4" id="profEmailLabel">{{
          'general.email' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="emailVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('email')"
              />
              <label for="emailVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="emailRequired"
                checked
                formControlName="isRequired"
              />
              <label for="emailRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="emailEditable"
                formControlName="isEditable"
              />
              <label for="emailEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profEmailDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      role="img"
                      class="flag flag-nl"
                      id="flag-nl-idc8"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profEmailLabel  profEmailDesc flag-nl-idc8"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc8"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profEmailLabel profEmailDesc flag-en-idc8"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc8"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profEmailLabel profEmailDesc flag-fr-idc8"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc8"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profEmailLabel profEmailDesc flag-de-idc8"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="language">
        <legend class="h4" id="profLanguage">{{
          'general.language' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="languageVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('language')"
              />
              <label for="languageVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="languageRequired"
                checked
                formControlName="isRequired"
              />
              <label for="languageRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="languageEditable"
                formControlName="isEditable"
              />
              <label for="languageEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profLangDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc9"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profLanguage profLangDesc flag-nl-idc9"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc9"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profLanguage profLangDesc flag-en-idc9"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc9"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profLanguage profLangDesc flag-fr-idc9"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc9"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profLanguage profLangDesc flag-de-idc9"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <!-- START OF ADDRESS FIELDS -->

      <fieldset formGroupName="street">
        <legend class="h4" id="profStreetLabel">{{
          'general.street' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('street')"
              />
              <label for="streetVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetRequired"
                checked
                formControlName="isRequired"
              />
              <label for="streetRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetEditable"
                formControlName="isEditable"
              />
              <label for="streetEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profStreetDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc10"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profStreetLabel profStreetDesc flag-nl-idc10"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc10"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profStreetLabel profStreetDesc flag-en-idc10"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc10"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profStreetLabel profStreetDesc flag-fr-idc10"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc10"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profStreetLabel profStreetDesc flag-de-idc10"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="houseNr">
        <legend class="h4" id="profHouseNoLabel">{{
          'general.houseNumber' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="houseNumberVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('houseNr')"
              />
              <label for="houseNumberVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="houseNumberRequired"
                checked
                formControlName="isRequired"
              />
              <label for="houseNumberRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="houseNumberEditable"
                formControlName="isEditable"
              />
              <label for="houseNumberEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profHouseNoDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc11"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profHouseNoLabel profHouseNoDesc flag-nl-idc11"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc11"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profHouseNoLabel profHouseNoDesc flag-en-idc11"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      id="flag-fr-idc11"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profHouseNoLabel profHouseNoDesc flag-fr-idc11"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      id="flag-de-idc11"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profHouseNoLabel profHouseNoDesc flag-de-idc11"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="city">
        <legend class="h4" id="profCityLabel">{{
          'general.city' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cityVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('city')"
              />
              <label for="cityVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cityRequired"
                checked
                formControlName="isRequired"
              />
              <label for="cityRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cityEditable"
                formControlName="isEditable"
              />
              <label for="cityEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profCityDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc12"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCityLabel profCityDesc flag-nl-idc12"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc12"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCityLabel profCityDesc flag-en-idc12"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc12"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCityLabel profCityDesc flag-fr-idc12"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc12"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCityLabel profCityDesc flag-de-idc12"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="postbox">
        <legend class="h4" id="profPostBoxLabel">{{
          'general.postbox' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="postboxVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('postbox')"
              />
              <label for="postboxVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="postboxRequired"
                checked
                formControlName="isRequired"
              />
              <label for="postboxRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="postboxEditable"
                formControlName="isEditable"
              />
              <label for="postboxEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="prodPBDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc13"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profPostBoxLabel prodPBDesc flag-nl-idc13"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc13"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profPostBoxLabel prodPBDesc flag-en-idc13"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc13"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profPostBoxLabel prodPBDesc flag-fr-idc13"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc13"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profPostBoxLabel prodPBDesc flag-de-idc13"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="country">
        <legend class="h4" id="profCountryLabel">{{
          'general.country' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="countryVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('country')"
              />
              <label for="countryVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="countryRequired"
                checked
                formControlName="isRequired"
              />
              <label for="countryRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="countryEditable"
                formControlName="isEditable"
              />
              <label for="countryEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profCountryDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc14"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCountryLabel profCountryDesc flag-nl-idc14"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc14"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCountryLabel profCountryDesc flag-en-idc14"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc14"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCountryLabel profCountryDesc flag-fr-idc14"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc14"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCountryLabel profCountryDesc flag-de-idc14"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="zipcode">
        <legend class="h4" id="profZipcodeLabel">{{
          'general.zipcode' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="zipcodeVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('zipcode')"
              />
              <label for="zipcodeVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="zipcodeRequired"
                checked
                formControlName="isRequired"
              />
              <label for="zipcodeRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="zipcodeEditable"
                formControlName="isEditable"
              />
              <label for="zipcodeEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profZipDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc15"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profZipcodeLabel  profZipDesc flag-nl-idc15"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc15"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profZipcodeLabel profZipDesc flag-en-idc15"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc15"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profZipcodeLabel profZipDesc flag-fr-idc15"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc15"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profZipcodeLabel profZipDesc flag-de-idc15"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="id">
        <legend class="h4" id="profIdLabel">{{
          'memberModule.personId' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="idVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('id')"
              />
              <label for="idVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="idRequired"
                checked
                formControlName="isRequired"
                disabled
              />
              <label for="idRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="idEditable"
                formControlName="isEditable"
                disabled
              />
              <label for="idEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profIdDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc16"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profIdLabel profIdDesc flag-nl-idc16"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc16"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profIdLabel profIdDesc flag-en-idc16"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc16"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profIdLabel profIdDesc flag-fr-idc16"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc16"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profIdLabel profIdDesc flag-de-idc16"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset
        *ngIf="!cfIsSelectedInMemberForm"
        formGroupName="chamberOfCommerceId"
        ><legend class="h4" id="profChamberLabel">{{
          'memberModule.chamberOfCommerce' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="chamberOfCommerceIdVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('chamberOfCommerceId')"
              />
              <label for="idVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="chamberOfCommerceIdRequired"
                formControlName="isRequired"
              />
              <label for="idRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="chamberOfCommerceIdEditable"
                formControlName="isEditable"
              />
              <label for="idEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profChamberDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc17"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profChamberLabel profChamberDesc flag-nl-idc17"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc17"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profChamberLabel profChamberDesc flag-en-idc17"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc17"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profChamberLabel profChamberDesc flag-fr-idc17"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc17"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profChamberLabel profChamberDesc flag-de-idc17"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="!cfIsSelectedInMemberForm" formGroupName="memo"
        ><legend class="h4" id="memoLabel">{{
          'general.memo' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="memoIdVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('memo')"
              />
              <label for="idVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="memoIdRequired"
                formControlName="isRequired"
              />
              <label for="idRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="memoIdEditable"
                formControlName="isEditable"
              />
              <label for="idEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="memoDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc28"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="memoLabel memoDesc flag-nl-idc28"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc28"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="memoLabel memoDesc flag-en-idc28"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc28"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="memoLabel memoDesc flag-fr-idc28"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc28"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="memoLabel memoDesc flag-de-idc28"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset *ngIf="!cfIsSelectedInMemberForm" formGroupName="balance"
        ><legend class="h4" id="profBalanceLabel">{{
          'memberModule.balance' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="balanceVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('balance')"
              />
              <label for="idVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="balanceRequired"
                formControlName="isRequired"
                disabled
              />
              <label for="idRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="balanceEditable"
                formControlName="isEditable"
                disabled
              />
              <label for="idEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profBalanceDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc18"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBalanceLabel profBalanceDesc flag-nl-idc18"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc18"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBalanceLabel profBalanceDesc flag-en-idc18"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc18"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBalanceLabel profBalanceDesc flag-fr-idc18"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc18"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBalanceLabel profBalanceDesc flag-de-idc18"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="!cfIsSelectedInMemberForm" formGroupName="externalKey">
        <legend class="h4" id="prodExternalLabel">{{
          'general.externalKey' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="externalKeyVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('externalKey')"
              />
              <label for="idVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="externalKeyRequired"
                formControlName="isRequired"
                disabled
              />
              <label for="idRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="externalKeyEditable"
                formControlName="isEditable"
                disabled
              />
              <label for="idEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profExternalDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc19"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="prodExternalLabel profExternalDesc flag-nl-idc19"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc19"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="prodExternalLabel profExternalDesc flag-en-idc19"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc19"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="prodExternalLabel profExternalDesc flag-fr-idc19"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc19"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="prodExternalLabel profExternalDesc flag-de-idc19"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="!cfIsSelectedInMemberForm" formGroupName="municipality">
        <legend class="h4" id="profMunicipalityLabel">{{
          'general.municipality' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="municipalityVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('municipality')"
              />
              <label for="idVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="municipalityRequired"
                formControlName="isRequired"
              />
              <label for="idRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="municipalityEditable"
                formControlName="isEditable"
              />
              <label for="idEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profMunicipDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc20"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMunicipalityLabel profMunicipDesc flag-nl-idc20"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc20"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMunicipalityLabel profMunicipDesc flag-en-idc20"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc20"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMunicipalityLabel profMunicipDesc flag-fr-idc20"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc20"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMunicipalityLabel profMunicipDesc flag-de-idc20"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="!cfIsSelectedInMemberForm" formGroupName="region">
        <legend class="h4" id="profRegionLabel">{{
          'general.region' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="regionVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('region')"
              />
              <label for="idVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="regionRequired"
                formControlName="isRequired"
              />
              <label for="idRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="regionEditable"
                formControlName="isEditable"
              />
              <label for="idEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profRegionDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc21"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profRegionLabel  profRegionDesc flag-nl-idc21"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc21"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profRegionLabel profRegionDesc flag-en-idc21"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc21"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profRegionLabel profRegionDesc flag-fr-idc21"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc21"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profRegionLabel profRegionDesc flag-de-idc21"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="!cfIsSelectedInMemberForm" formGroupName="gender">
        <legend class="h4" id="profGenderLabel">{{
          'general.gender' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="genderVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('gender')"
              />
              <label for="idVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="genderRequired"
                formControlName="isRequired"
              />
              <label for="idRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="genderEditable"
                formControlName="isEditable"
              />
              <label for="idEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profGenderDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc22"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profGenderLabel  profGenderDesc flag-nl-idc22"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc22"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profGenderLabel profGenderDesc flag-en-idc22"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc22"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profGenderLabel  profGenderDesc flag-fr-idc22"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc22"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profGenderLabel profGenderDesc flag-de-idc22"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="!cfIsSelectedInMemberForm" formGroupName="memberNumber">
        <legend class="h4" id="profMemberNrLabel">{{
          'memberModule.memberNumber' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="memberNumberVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('memberNumber')"
              />
              <label for="idVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="memberNumberRequired"
                formControlName="isRequired"
              />
              <label for="idRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="memberNumberEditable"
                formControlName="isEditable"
              />
              <label for="idEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profMemberNrDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc23"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMemberNrLabel profMemberNrDesc flag-nl-idc23"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc23"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMemberNrLabel profMemberNrDesc flag-en-idc23"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc23"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMemberNrLabel profMemberNrDesc flag-fr-idc23"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc23"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profMemberNrLabel profMemberNrDesc flag-de-idc23"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="!cfIsSelectedInMemberForm" formGroupName="cardNumber">
        <legend class="h4" id="profCardNrLabel">{{
          'memberModule.cardNumber' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cardNumberVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('cardNumber')"
              />
              <label for="cardNumberVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cardNumberRequired"
                formControlName="isRequired"
              />
              <label for="cardNumberRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cardNumberEditable"
                formControlName="isEditable"
              />
              <label for="cardNumberEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profCardNrDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-cardNumber"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCardNrLabel profCardNrDesc flag-nl-cardNumber"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-cardNumber"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCardNrLabel profCardNrDesc flag-en-cardNumber"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-cardNumber"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCardNrLabel profCardNrDesc flag-fr-cardNumber"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-cardNumber"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profCardNrLabel profCardNrDesc flag-de-cardNumber"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="!cfIsSelectedInMemberForm" formGroupName="group">
        <legend class="h4" id="profStatusLabel">{{
          'memberModule.group' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="groupVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('group')"
              />
              <label for="idVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="groupRequired"
                formControlName="isRequired"
              />
              <label for="idRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="groupEditable"
                formControlName="isEditable"
              />
              <label for="idEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profGroupDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc24"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profGroupLabel  profGroupDesc flag-nl-idc24"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc24"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profGroupLabel profGroupDesc flag-en-idc24"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc24"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profGroupLabel profGroupDesc flag-fr-idc24"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc24"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profGroupLabel profGroupDesc flag-de-idc24"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="!cfIsSelectedInMemberForm" formGroupName="status">
        <legend class="h4" id="profStatusLabel">{{
          'general.status' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="statusVisible"
                formControlName="isVisible"
                (change)="onVisibleInputChange('status')"
              />
              <label for="idVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="statusRequired"
                formControlName="isRequired"
              />
              <label for="idRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="statusEditable"
                formControlName="isEditable"
              />
              <label for="idEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profStatusDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc24"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profStatusLabel  profStatusDesc flag-nl-idc24"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc24"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profStatusLabel profStatusDesc flag-en-idc24"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc24"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profStatusLabel profStatusDesc flag-fr-idc24"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc24"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profStatusLabel profStatusDesc flag-de-idc24"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <!-- END OF ADDRESS FIELDS -->

      <div class="form-footer sticky-bottom">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>

<form
  [formGroup]="formNotifications"
  (ngSubmit)="onSubmitNotifications()"
  [patchForm]="optionValueNotification$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
  #formRef="ngForm"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsedNotifications ? 'false' : 'true'"
          (click)="isCollapsedNotifications = !isCollapsedNotifications"
          aria-controls="notifications"
        >
          <span class="fs-3">
            {{ 'configurationOptionModule.notifications' | translate }}</span
          >
          <i
            class="fa fa-fw"
            [ngClass]="
              isCollapsedNotifications ? 'fa-chevron-down' : 'fa-chevron-up'
            "
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsedNotifications" class="card-body" id="notifications">
      <fieldset>
        <legend class="h4">{{
          'memberModule.notificationsOffers' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4"> </div>
          <div class="col">
            <div class="form-check col-sm mb-2">
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="notificationsAgreementsDisplayOffers"
                  formControlName="notifications_agreements_display_offers"
                />
                <label for="notificationsAgreementsDisplayOffers">{{
                  'general.isVisible' | translate | titlecase
                }}</label>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend class="h4">{{
          'memberModule.notificationsNewsletters' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4"> </div>
          <div class="col">
            <div class="form-check col-sm mb-2">
              <div class="form-check">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="notificationsAgreementsDisplayNewsletters"
                  formControlName="notifications_agreements_display_newsletters"
                />
                <label for="notificationsAgreementsDisplayNewsletters">{{
                  'general.isVisible' | translate | titlecase
                }}</label>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>

<form
  [formGroup]="formBankAccount"
  (ngSubmit)="onSubmitBankAccount()"
  #formRefBankAccount="ngForm"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
  [patchForm]="optionValueBankAccount$ | async"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsedBankAccount ? 'false' : 'true'"
          (click)="isCollapsedBankAccount = !isCollapsedBankAccount"
          aria-controls="bankAccountDetails"
        >
          <span class="fs-3">
            {{ 'general.bankAccountDetails' | translate }}
          </span>
          <i
            class="fa fa-fw"
            [ngClass]="
              isCollapsedBankAccount ? 'fa-chevron-down' : 'fa-chevron-up'
            "
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div
      *ngIf="!isCollapsedBankAccount"
      class="card-body"
      id="bankAccountDetails"
    >
      <div class="nav nav-segment my-2">
        <button
          type="button"
          (click)="$event.preventDefault(); setFormBankAccountValues()"
          class="nav-segment nav-link"
          [ngClass]="!cfIsSelectedInBankAccountForm ? ' active' : ''"
        >
          {{
            'configurationOptionModule.apProductGroupPurchaseFlow' | translate
          }}
        </button>

        <button
          type="button"
          (click)="$event.preventDefault(); setFormBankAccountValues()"
          class="nav-segment nav-link"
          [ngClass]="cfIsSelectedInBankAccountForm ? ' active' : ''"
        >
          {{
            'configurationOptionModule.cfProductGroupPurchaseFlow' | translate
          }}
        </button>
      </div>

      <fieldset formGroupName="bankAccount">
        <legend class="h4" id="profBankAccountDetailsLabel">{{
          'general.bankAccount' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="bankAccountVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('bankAccount')"
              />
              <label for="bankAccountVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="bankAccountRequired"
                checked
                formControlName="isRequired"
              />
              <label for="bankAccountRequired">{{
                'general.isRequired' | translate | titlecase | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="bankAccountEditable"
                formControlName="isEditable"
              />
              <label for="bankAccountEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profBankDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc25"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBankAccountDetailsLabel profBankDesc flag-nl-idc25"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc25"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBankAccountDetailsLabel profBankDesc flag-en-idc25"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc25"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBankAccountDetailsLabel profBankDesc flag-fr-idc25"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc25"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBankAccountDetailsLabel profBankDesc flag-de-idc25"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="bankAccountHolder">
        <legend class="h4" id="profBankAccountLabel">{{
          'general.bankAccountHolder' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="bankAccountHolderVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('bankAccountHolder')"
              />
              <label for="bankAccountHolderVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="bankAccountHolderRequired"
                formControlName="isRequired"
              />
              <label for="bankAccountHolderRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="bankAccountHolderEditable"
                formControlName="isEditable"
              />
              <label for="bankAccountHolderEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profBankHolderDesc">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      id="flag-nl-idc26"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBankAccountLabel profBankHolderDesc flag-nl-idc26"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      id="flag-en-idc26"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBankAccountLabel profBankHolderDesc flag-en-idc26"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      id="flag-fr-idc26"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBankAccountLabel profBankHolderDesc flag-fr-idc26"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      id="flag-de-idc26"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profBankAccountLabel profBankHolderDesc flag-de-idc26"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
